import { render, staticRenderFns } from "./PeriodSegmented.vue?vue&type=template&id=428fbd06&scoped=true&"
import script from "./PeriodSegmented.vue?vue&type=script&lang=js&"
export * from "./PeriodSegmented.vue?vue&type=script&lang=js&"
import style0 from "./PeriodSegmented.vue?vue&type=style&index=0&id=428fbd06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428fbd06",
  null
  
)

export default component.exports